import 'select2';
import 'select2/dist/css/select2';

import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    placeholder: String,
  }

  connect() {
    $(this.element).select2({
      multiple: true,
      placeholder: this.placeholderValue || '-- selecione --',
      allowClear: true,
      language: 'pt-BR',
    });
  }

  disconnect() {
    $(this.element).select2('destroy');
  }
};
